<template>
  <div class="backStack-issue-wrap informationCreate">
    <From
      ref="formRef"
      layoutType="grid"
      :isErrorMessage="false"
      :optionList="formRows"
      :formRules="formRules"
      :defaultModel="defaultModel"
    >
    </From>
    <div class="backStack-issue-footer-wrap">
      <div class="submit-wrap">
        <!-- <a-button class="submit-audit" @click="preView">保存预览</a-button> -->
        <a-button class="submit-audit" @click="toAudit(0)">保存</a-button>
        <a-button class="submit-audit" @click="toAudit(1)">保存并发布</a-button>
      </div>
    </div>
  </div>
</template>

<script>
import From from '../../components/formTable/form.vue'
import mixinsBackStack from '@/mixins/backStack'
import mixinConfigSetting from '@/mixins/mixinConfigSetting'
import mixinFakeData from '@/mixins/makeFakerData'
import { formRules, formRows } from './configs/formOptions.js'
import {
  checkInformationInfos,
  editInformationInfos
} from '@/api/informationInfos.js'

export default {
  mixins: [mixinsBackStack, mixinConfigSetting, mixinFakeData],
  data() {
    return {
      loading: true,
      formRows, // 表单item配置
      formRules, // 表单校验规则配置
      defaultModel: {
        // 默认值
        // title: '测试专利',
        // demandType: 'technology',
        // price: '10000',
        // mainSubject: 'stateOwner',
        // description: '这是一条测试数据的描述'
      },
      detailId: null,
      isRead: false
    }
  },
  components: {
    From
  },
  created() {
    this.initSetting()
  },
  methods: {
    // 初始化数据
    initSetting() {
      const { id } = this.$route.query
      this.detailId = id
      this.initDefaultModel()
    },
    // 获取默认值
    async initDefaultModel() {
      const { data } = await checkInformationInfos(this.detailId)
      this.handleResult(data)
    },
    handleResult(instance) {
      console.log(instance)
      const { fileAnnes, fileVo, ...otherParams } = instance
      this.defaultModel = {
        ...otherParams,
        annexIds: fileAnnes,
        picPath: fileVo
      }
    },
    readChange(e) {
      const { target } = e
      this.isRead = target.checked
    },
    // 参数处理
    beforeRequest() {
      const { detailId } = this
      const { picPath, ...formValue } = this.$refs.formRef.formModel
      const annexIds = this.handlerAnnexIds(formValue).join(',')
      const pic = this.handlerPicPathIds(picPath).join(',')
      const params = { ...formValue, id: detailId, annexIds, pic }
      return params
    },
    handlerAnnexIds(instance) {
      const { annexIds } = instance
      if (!annexIds) return []
      return annexIds.reduce((pre, item) => {
        if (item.response) {
          const { fileId } = item.response.data[0]
          pre.push(fileId)
        } else {
          pre.push(item.id)
        }
        return pre
      }, [])
    },
    handlerPicPathIds(picPath) {
      if (!picPath) return []
      return picPath.reduce((pre, item) => {
        if (item.response) {
          const { fileId } = item.response.data[0]
          pre.push(fileId)
        } else {
          pre.push(item.id)
        }
        return pre
      }, [])
    },
    async toAudit(status) {
      const v = this.$refs.formRef.validatedForm()
      if (!v) return
      const params = this.beforeRequest()
      params.status = status
      const { msg, code } = await editInformationInfos(params)
      this.$apiStatusHandler(code, msg)
      this.$router.push({ name: 'informationInfos' })
    }
  }
}
</script>
